import { Component, Input } from '@angular/core';
import { LMPartProgress } from '@services/file-upload/lm-xlfile-upload.service';
import { Observable } from 'rxjs';

interface LMPartProgressData extends LMPartProgress {
  partLabel: string;
  partPercent: string;
}

@Component({
  selector: 'lm-file-upload-progress',
  standalone: false,
  templateUrl: './lm-file-upload-progress.component.html',
  styleUrls: ['./lm-file-upload-progress.component.scss']
})
export class LMFileUploadProgressComponent {
  public progressPercent = '0%';
  public progressValue = 0;
  public partProgress: Array<LMPartProgressData> = [];

  @Input() set progress(value: number) {
    this.progressValue = value;
    this.progressPercent = `${value}%`;
  }

  @Input() xlFile = false;
  @Input() set totalParts(total: number) {
    let i = 0;
    while (i < total) {
      const partLabel = `${Soho.Locale.translate('Part')} ${(i + 1)}: `;
      this.partProgress[i] = { part: i + 1, partLabel: partLabel, progress: 0, partPercent: '0%' };
      i++;
    }
  }

  @Input() set uploadProgress$(o: Observable<LMPartProgress>) {
    o.subscribe((p: LMPartProgress) => {
      if (this.partProgress?.length > 0 && this.partProgress[p.part - 1] !== undefined) {
        this.partProgress[p.part - 1].progress = p.progress;
        this.partProgress[p.part - 1].partPercent = `${p.progress}%`;
        this.partProgress = structuredClone(this.partProgress);
      }
    });
  }

  @Input() completeUpload = false;
}
